import { createRef } from "react";

export const notistackRef = createRef();

export const navigateRef = createRef();
